import { FormEvent, createRef } from 'react'
import { Dispatch } from 'redux'
import { connect } from 'react-redux'

import ReduxStoreInterface from '../../interfaces/client/ReduxStore'
import NotificationInterface from '../../interfaces/client/Notification'

import notificationTypes from '../../config/notificationTypes'

import { resetBooking, createBooking } from '../../actions/bookings'
import {
  resetNotifications,
  removeNotification,
} from '../../actions/notifications'

import buildPassengersFromFormValues from '../../utils/forms/buildPassengersFromFormValues'
import getFormValuesWithoutRef from '../../utils/getFormValuesWithoutRef'
import isPassengerNotBooked from '../../utils/passengers/isPassengerNotBooked'
import getGlobalWarningNotifications from '../../utils/notifications/getGlobalWarningNotifications'
import getGlobalInfoNotifications from '../../utils/notifications/getGlobalInfoNotifications'
import getGlobalSuccessNotifications from '../../utils/notifications/getGlobalSuccessNotifications'
import getGlobalErrorNotifications from '../../utils/notifications/getGlobalErrorNotifications'

import NewBookingForm from '../../components/NewBookingForm'
import { requestFlight } from '../../actions/flights'

export interface NewBookingFormPropsInterface {
  setIsFormSubmittable: Function
  setIsCSVUploadable: Function

  departureFlightId: string
  returnFlightId: string
  smartClassAllotmentCount: number
  economyAllotmentCount: number

  isTOFlight: boolean
  isFormSubmittable: boolean
}

export const mapStateToProps = (
  state: ReduxStoreInterface,
  props: NewBookingFormPropsInterface
) => {
  const {
    setIsFormSubmittable,
    setIsCSVUploadable,
    departureFlightId,
    returnFlightId,
    smartClassAllotmentCount,
    economyAllotmentCount,
    isTOFlight,
    isFormSubmittable,
  } = props
  const notifications = state.notifications.allIds.map(
    (id: string) => state.notifications.byId[id]
  )
  const warningNotifications = getGlobalWarningNotifications(notifications)
  const infoNotifications = getGlobalInfoNotifications(notifications)
  const successNotifications = getGlobalSuccessNotifications(notifications)
  const errorNotifications = getGlobalErrorNotifications(notifications)

  const formContainsErrorOrWarning = notifications.filter(
    (notification: NotificationInterface) =>
      !notification.isGlobal &&
      (notification.type === notificationTypes.warning ||
        notification.type === notificationTypes.error)
  )

  const formContainsNoError = Boolean(!formContainsErrorOrWarning.length)
  const isBookingPassengers = Boolean(
    state.requests.isFetchingPassengers.length
  )

  return {
    createRef,
    isTOFlight,
    departureFlightId,
    returnFlightId,
    smartClassAllotmentCount,
    economyAllotmentCount,
    setIsFormSubmittable,
    setIsCSVUploadable,
    isFormSubmittable,

    isResetFormButtonDisabled: !isFormSubmittable,
    isCreateBookingButtonDisabled: !isFormSubmittable,
    formContainsNoError,
    isBookingPassengers,

    notifications: [...infoNotifications, ...successNotifications],
    errors: [...warningNotifications, ...errorNotifications],
    amountOfUploadedPassengers: state.uploadedPassengers.allIds.length,
    amountOfFormErrors: formContainsErrorOrWarning.length,
  }
}

export const mapDispatchToProps = (dispatch: Dispatch) => ({
  handleSubmit: (event: FormEvent<HTMLFormElement>, flightIds: string[]) => {
    event.preventDefault()

    if (event.currentTarget) {
      const formValues = getFormValuesWithoutRef(
        Array.from(event.currentTarget.elements)
      )

      const passengers = buildPassengersFromFormValues(formValues).filter(
        isPassengerNotBooked
      )

      if (Boolean(passengers.length)) {
        dispatch(resetNotifications())
        dispatch(
          createBooking(
            flightIds.filter((flightId: string) => flightId),
            passengers
          )
        )
      }
    }
  },
  resetForm: (event: FormEvent<HTMLFormElement>, flightIds: string[] = []) => {
    event.preventDefault()

    const form = event.currentTarget.form

    if (!form) return

    flightIds
      .filter((flightId: string) => flightId)
      .forEach((flightId: string) => {
        dispatch(requestFlight(flightId))
      })

    form.reset()

    dispatch(resetBooking())
    dispatch(resetNotifications())
  },
  removeNotification: (notification: NotificationInterface) => {
    dispatch(removeNotification(notification.id))
  },
  removeNotifications: () => {
    dispatch(resetNotifications())
  },
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(NewBookingForm)
